import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { each } from 'async';
import { CSVLink } from 'react-csv';

const MetricTableView = ({ metricData, height }) => {
	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState([]);

	const today = new Date();
	const csvDate = `${today.getFullYear()}_${
		today.getMonth() + 1
	}_${today.getDate()}`;

	useEffect(() => {
		if (metricData && metricData.lineData2) {
			setCurrentData(metricData.lineData2);
		}
	}, [metricData]);

	// console.log('metricFilter', metricFilter);
	// console.log('metricData', metricData);
	// console.log('rowsData', rowsData);
	// console.log('channels', channels);
	// console.log('currentData', currentData);

	useEffect(() => {
		if (currentData) {
			const tableLabels = [];
			const tableHeaders = [];

			tableHeaders.push({
				label: 'Dates',
				field: 'Dates',
			});
			let dates = [];
			const metricNames = [];
			currentData &&
				currentData.forEach((e, i) => {
					if (e.label) {
						const d2 = {
							label: e.label,
							field: e.label,
						};
						tableHeaders.push(d2);
						tableLabels.push(e);
					}
					if (e.labels) {
						dates.push(e.labels);
						tableLabels.push({ label: 'Dates', data: e.labels });
					}
				});

			console.log('tableLabels', tableLabels);
			const datesArr = [];

			dates &&
				dates.map((nDates, idx) => {
					return nDates.forEach((e) => {
						datesArr.push(e);
					});
				});

			// console.log('tableHeaders', tableHeaders);

			const headers = tableLabels && tableLabels.map((obj) => obj.label);

			const headersAndData = {};
			tableLabels &&
				tableLabels.forEach(
					({ label, data }) => (headersAndData[label] = data)
				);

			const format = datesArr.map((date, dIndex) => {
				let rowData = { date };
				// loop headers and assign value base on dIndex
				headers.forEach((h) => {
					// get current header value
					const value = headersAndData[h][dIndex];
					rowData[h] = value;
				});

				return rowData;
			});
			// console.log('format', format);
			setRowsData({
				columns: tableHeaders,
				rows: format ? format : [],
			});
		}
	}, [currentData]);

	// console.log('rowsD ata', rowsData);

	return (
		<div>
			<h5 className='fw-bold text-mute'> Metric Table</h5>
			<div
				style={{
					height: height ? height : '370px',
					overflowY: 'scroll',
					overflowX: 'hidden',
				}}>
				<MDBDataTable
					data={rowsData}
					bordered
					noBottomColumns
					small
					responsive
					hover
					paging={false}
					searching={false}
				/>
			</div>

			{rowsData && rowsData.rows && (
				<div className='text-white'>
					<CSVLink
						className='badge rounded-pill bg-primary'
						data={rowsData.rows && rowsData.rows}
						// headers={rowsData.columns}
						filename={`dashboard${csvDate}.csv`}
						target='_blank'>
						Download as CSV
					</CSVLink>
				</div>
			)}
		</div>
	);
};

export default MetricTableView;
